import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { contactFormFields } from '../data/mockData';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    presupuesto: '',
    mensaje: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setFormData({
      nombre: '',
      email: '',
      telefono: '',
      presupuesto: '',
      mensaje: ''
    });
  };

  return (
    <section className="contact-section" id="contact-form">
      <div className="section-header">
        <div className="section-line red" />
        <h2 className="section-title">SOLICITA TU PRESUPUESTO</h2>
        <div className="section-line red" />
      </div>
      <p className="section-subtitle">
        Cuéntanos qué buscas y te contactamos en 24 horas
      </p>
      <form className="contact-form" onSubmit={handleSubmit}>
        {contactFormFields.map((field) => (
          <div key={field.id} className="form-group">
            <label className="form-label">{field.label}</label>
            <input
              type={field.type}
              name={field.id}
              placeholder={field.placeholder}
              value={formData[field.id] || ''}
              onChange={handleChange}
              required={field.required}
              className="form-input"
            />
          </div>
        ))}
        <div className="form-group">
          <label className="form-label">Mensaje</label>
          <textarea
            name="mensaje"
            placeholder="Cuéntanos qué modelo, año, color o características buscas..."
            value={formData.mensaje}
            onChange={handleChange}
            rows={4}
            className="form-textarea"
          />
        </div>
        <button type="submit" className="submit-btn">
          <span>{submitted ? '¡Enviado!' : 'Enviar Solicitud'}</span>
          {!submitted && <ArrowRight size={20} />}
        </button>
      </form>
    </section>
  );
};

export default ContactForm;
